import React from "react";
import styled from "styled-components";
import "styled-components/macro";
import { RadioProceed } from "../../../component/component.style";
function PlanDetails() {
  return (
    <Section>
      <HeadingLabel>
        Your recommended Sum Assured was calculated in the following way!
      </HeadingLabel>
      <TableHeading>Summation of:</TableHeading>
      <table>
        <Row>
          <TableHeader>Required Annual Income Replacement</TableHeader>
          <TableData>₹ 1200</TableData>
        </Row>
        <Row>
          <TableHeader>Replacement for Income from Other Sources</TableHeader>
          <TableData>₹ 1200</TableData>
        </Row>
        <Row>
          <TableHeader>
            Projected Value of Education Expense for your Children
          </TableHeader>
          <TableData>₹ 1200</TableData>
        </Row>
        <Row>
          <TableHeader>Your Total Debt</TableHeader>
          <TableData>₹ 1200</TableData>
        </Row>
        <Row>
          <TableHeader>Required Annual Income Replacement</TableHeader>
          <TableData>₹ 1200</TableData>
        </Row>
      </table>
      <TableHeading>LESS:</TableHeading>
      <table>
        <Row>
          <TableHeader>
            Partner's contribution in household expenses
          </TableHeader>
          <TableData>(₹ 1200)</TableData>
        </Row>
        <Row>
          <TableHeader>Your accumulated Savings</TableHeader>
          <TableData>(₹ 1200)</TableData>
        </Row>
        <Row>
          <TableHeader>Your current life coverage</TableHeader>
          <TableData>(₹ 1200)</TableData>
        </Row>
      </table>
      <div
        css={`
          margin: 20px;
          margin-top: 25px;
          display: flex;
          justify-content: center;
        `}
      >
        <RadioProceed>Proceed</RadioProceed>
      </div>
    </Section>
  );
}

export default PlanDetails;

const Section = styled.div`
  position: relative;
  transform: perspective(1px) translateZ(0);
  background: #fff;
  padding: 10px 0px 10px 32px;
  border-radius: 8px;
  box-shadow: 0px 30px 70px 0px rgb(226 232 236 / 50%);
  margin: 8px 0px;
  min-width: 550px;
`;
const HeadingLabel = styled.h2`
  font-size: 16px !important;
  line-height: 43px !important;

  font-weight: 900 !important;
  margin-top: 0px;
  text-align: left;
`;

const TableHeading = styled.h6`
  font-size: 15px !important;
  line-height: 28px;
  font-family: "Roboto", sans-serif;
  margin-bottom: 5px !important;
  color: #131313 !important;
  text-transform: uppercase !important;
`;

const Row = styled.tr`
  vertical-align: baseline;
  text-decoration: none;
  margin: 0;
`;
const TableHeader = styled.th`
  width: 400px;
  padding: 8px 0;
  text-align: left;
  color: #4e4e4e;
  font-size: 14px;
  line-height: 28px;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
`;

const TableData = styled.td`
  text-align: center;
  color: #4e4e4e;
  font-size: 14px;
  padding: 8px 0;
  width: 150px;
`;
